const CHANGED_OPTIONS_FOR_DESKTOP = 'desktop';
const CHANGED_OPTIONS_FOR_TABLET = 'tablet';
const CHANGED_OPTIONS_FOR_MOBILE = 'mobile';

const generateChangedOptionsTraits = ({
  desktopTraits = {},
  tabletTraits = {},
  mobileTraits = {},
} = {}) => ({
  ...(Object.keys(desktopTraits).length > 0
    ? { [CHANGED_OPTIONS_FOR_DESKTOP]: desktopTraits }
    : {}),
  ...(Object.keys(tabletTraits).length > 0 ? { [CHANGED_OPTIONS_FOR_TABLET]: tabletTraits } : {}),
  ...(Object.keys(mobileTraits).length > 0 ? { [CHANGED_OPTIONS_FOR_MOBILE]: mobileTraits } : {}),
});

export default generateChangedOptionsTraits;
